import { ServerStatistics } from "@/utils/ServerStatistics"

// initial state
const state = () => ({
  countShardsForHours: [],
  isUpdated: false,
  guestsData: {
    total: 0
  },
  standmans: [],
  survey: {
    count: 0,
    stat: []
  },
  targetMyData: {
    items: []
  }
})

// getters
const getters = {
  getTargetMyData: (state: any) => state.targetMyData,
  getShardsForHours: (state: any) => state.countShardsForHours,
  getGuestsCount: (state: any) => state.guestsData.total,
  getStandmans: (state: any) => state.standmans,
  getSurveyCount: (state: any) => state.survey.count,
  getSurveyStat: (state: any) => state.survey.stat,
  getUpdateStatus: (state: any) => state.isUpdated,
  countStandmansSurveyAndShard: (state: any) => {
    let count = { surveys: 0, shards: 0 };

    state.standmans.forEach((element: any) => {
      count.surveys += element.surveyCount;
      count.shards += element.shardCount;
    });

    return count;
  },
};

// actions
const actions = {
  getStatistics(context: any, exhibitor: any) {
    ServerStatistics.getStatistics(exhibitor).then((res) => {
      // console.log(res.data) //получение данных по статистике
      context.commit("setStats", res.data);
    });
  },
};

// mutations
const mutations = {
  setStats(state: any, stats: any) {
    state.countShardsForHours = stats.countShardsForHours;
    state.guestsData = stats.guestsData;
    state.standmans = stats.standmans;
    state.survey = stats.survey;
    state.targetMyData = stats.targetMyData;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
